import { IResponse, consumer } from '@bemap/utils';

const ENDPOINT = '/reports'

export const getAdminDashboard = async (): Promise<IResponse> => {
  return consumer('GET', `${ENDPOINT}/admin-dashboard`);
}

export const getPartnerDashboard = async (): Promise<IResponse> => {
  return consumer('GET', `${ENDPOINT}/partner-dashboard`);
}

export const getAnalystDashboard = async (): Promise<IResponse> => {
  return consumer('GET', `${ENDPOINT}/analyst-dashboard`);
} 